<app-header 
  [icon]="'arrow_back_ios'"
  (iconClickedEvent)="back()">
</app-header>
<div class="container">
  <img src="imgs/icon.png" class="logo-icon">
  <div class="title">
    MyMindLog
  </div>
  <div class="sub-title">
    {{'invite-patient.account' | translate}}
  </div>
  <div class="form-container">
    <form [formGroup]="inviteForm" class="form">
      <app-input 
        [label]="'labels.email' | translate"
        [placeholder]="'placeholders.email' | translate"
        [formControl]="emailControl"
        type="email"
      ></app-input>

      <app-input 
        [label]="'labels.first_name' | translate"
        [placeholder]="'placeholders.first_name' | translate"
        [formControl]="firstNameControl"
        type="text"
      ></app-input>
      
      <app-input 
        [label]="'labels.last_name' | translate"
        [placeholder]="'placeholders.last_name' | translate"
        [formControl]="lastNameControl"
        type="text"
      ></app-input>

      <app-input 
        [label]="'labels.birthdate' | translate"
        [placeholder]="'placeholders.birthdate' | translate"
        [formControl]="birthdateControl"
        type="date"
      ></app-input>

      <div class="phone-container">
        <img src="/imgs/wapp_logo.png" alt="">
        <p>{{ 'invite-patient.wapp' | translate }}</p>
        
        <p class="label">{{ 'labels.country_code' | translate }}</p>
        <mat-form-field appearance="outline">
          <mat-select [formControl]="dialCodeControl" >
            @for (group of COUNTRY_GROUPS; track group.name) {
              <mat-optgroup [label]="group.name | translate">
                @for (item of sortCountriesByTranslatedName(group.countries); track item.iso) {
                  <mat-option [value]="item.dial_code">{{item.name | translate}} {{'('+item.dial_code+')'}}</mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
        </mat-form-field>
        @if (
          dialCodeControl.invalid 
          && dialCodeControl.errors
          && (dialCodeControl.touched || dialCodeControl.dirty)
        ) {
          @if (dialCodeControl.errors['required']) {
            <div class="error">
              {{ 'errors.field_required' | translate }}
            </div>
          } @else {
            <div class="error">
              {{ 'errors.invalid_field' | translate }}
            </div>
          }
        }

        <app-input 
          [label]="'labels.phone' | translate"
          [placeholder]="'placeholders.phone' | translate"
          [formControl]="phoneNumberControl"
          type="tel"
        ></app-input>
      </div>
    </form>

    <div class="actions-container">
      <app-button
        [buttonLabel]="'buttons.cancel' | translate"
        [buttonType]="BUTTON_TYPES.OUTLINED" 
        (click)="back()">
      </app-button>
      <app-button
        [buttonLabel]="'buttons.save' | translate"
        [buttonType]="BUTTON_TYPES.REGULAR" 
        [buttonDisabled]="isFormInvalid()"
        (click)="saveInvite()">
      </app-button>
    </div>
    
  </div>
</div>